module.exports = __webpack_public_path__ + "static/media/arrow-left-icon.8e654ce8.svg";